import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ba84110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "infoBlockBeginning" }
const _hoisted_2 = { class: "infoBlockBeginning__text" }
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = { class: "balances" }
const _hoisted_5 = { class: "balance" }
const _hoisted_6 = { class: "balance__title" }
const _hoisted_7 = { class: "balance__num" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "USDT", -1))
const _hoisted_9 = {
  key: 0,
  class: "balance-otonq"
}
const _hoisted_10 = { class: "balance-otonq__include" }
const _hoisted_11 = { class: "balance-otonq__num" }
const _hoisted_12 = { class: "inputsBox" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "inputErrorInfo"
}
const _hoisted_15 = { class: "sumBox" }
const _hoisted_16 = { class: "inputItem" }
const _hoisted_17 = { class: "sumInfo" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "feeInfo" }
const _hoisted_20 = { class: "i" }
const _hoisted_21 = { class: "button" }
const _hoisted_22 = {
  key: 0,
  class: "infoBlock"
}
const _hoisted_23 = {
  key: 1,
  class: "infoBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_CommonTabs = _resolveComponent("CommonTabs")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_CommonButtonPrimary = _resolveComponent("CommonButtonPrimary")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createBlock(_component_CommonModal, {
    name: _ctx.modalName,
    title: _ctx.$t('Withdraw from {currency} balance', { currency: 'USDT' })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CommonLoader, {
        state: _ctx.frozenState,
        isPlaceholder: ""
      }, null, 8, ["state"]),
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_CommonTabs, {
          currentTab: _ctx.data.tab,
          tabs: _ctx.tabsList,
          onClick: _ctx.changeTab
        }, null, 8, ["currentTab", "tabs", "onClick"]),
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("withdraw-oton-info")), 1)
        ], 512), [
          [_vShow, _ctx.data.tab === 'bep20']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("Available for withdrawal")), 1),
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.otonBalance.limit) + " ", 1),
                _hoisted_8
              ])
            ]),
            (_ctx.otonqInNum !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("Включая к выводу без комиссии")), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(String(_ctx.otonqInNum.toFixed(3)).replace(
                /(\d)(?=(\d{3})+([^\d]|$))/g,
                "$1 "
              )), 1),
                  _createTextVNode(" OTON ")
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.data.tab === 'bep20']
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms[_ctx.data.tab], (input) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['inputItem', input.addClass]),
              key: input.name
            }, [
              _createVNode(_component_CommonInput, _mergeProps(input, {
                modelValue: _ctx.data[input.name],
                disabled: "",
                "onUpdate:modelValue": ($event: any) => (_ctx.onChange(input.name, $event)),
                inputSuffixClass: '',
                hasError: !_ctx.data.bep20,
                required: ""
              }), {
                default: _withCtx(() => [
                  (_ctx.data[input.name])
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t(input.label)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.$t('Please fill your BEP20-address in')) + " ", 1),
                        _createVNode(_component_router_link, { to: "/profile" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('Profile')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 2
              }, 1040, ["modelValue", "onUpdate:modelValue", "hasError"])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_CommonInput, {
              fontWeight: "700",
              type: "string",
              modelValue: _ctx.data.sum,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange('sum', $event))),
              hasError: !_ctx.isValidSum,
              required: "",
              mask: "#*"
            }, {
              suffix: _withCtx(() => [
                _createTextVNode("USDT")
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Withdrawal amount")) + " ", 1)
              ]),
              _: 1
            }, 8, ["modelValue", "hasError"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.$t("{sum} fee", { sum: `${_ctx.feesValues.oton} USDT` })) + " ", 1),
            _hoisted_18,
            _createTextVNode(" (" + _toDisplayString(_ctx.$t("{percents}%, minimum {sum}", {
              percents: 1,
              sum: `20 USDT`,
            })) + ") ", 1)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("No fee")), 1)
        ], 512), [
          [_vShow, _ctx.data.tab === 'paystree']
        ]),
        _createElementVNode("div", _hoisted_21, [
          _withDirectives(_createVNode(_component_CommonButtonPrimary, {
            type: "submit",
            disabled: !_ctx.isValidSum || !_ctx.data.bep20
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Withdraw")) + " " + _toDisplayString(_ctx.sumWithFee) + " USDT ", 1)
            ]),
            _: 1
          }, 8, ["disabled"]), [
            [_vShow, _ctx.data.tab === 'bep20']
          ])
        ]),
        (_ctx.data.tab === 'bep20')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t("Payouts are done manually and can take up to 72 hours.")), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t("Withdrawal is carried out within 14 days")) + ". ", 1))
      ], 32)
    ]),
    _: 1
  }, 8, ["name", "title"]))
}